'use client'

import { useMediaQuery } from '@/utils/hooks/use-media-query'
import { IChildrenProps } from '@/utils/typings/children-props'
import { createContext, useContext, useMemo } from 'react'

export interface IScreenContext {
    isMobile: boolean | undefined
    isTablet: boolean | undefined
    isDesktop: boolean | undefined
    isLargeDesktop: boolean | undefined
}

const ScreenContext = createContext<IScreenContext>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isLargeDesktop: false,
})

export const ScreenContextProvider = ({ children }: IChildrenProps) => {
    const isMobile = useMediaQuery('(max-width: 768px)')
    const isTablet = useMediaQuery('(max-width: 1280px)')
    const isDesktop = useMediaQuery('(min-width: 1281px)')
    const isLargeDesktop = useMediaQuery('(min-width: 1536px)')

    const value = useMemo<IScreenContext>(
        () => ({ isMobile, isTablet, isDesktop, isLargeDesktop }),
        [isMobile, isTablet, isDesktop, isLargeDesktop]
    )

    return <ScreenContext.Provider value={value}>{children}</ScreenContext.Provider>
}

export const useScreenContext = () => useContext(ScreenContext)
